import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["leafBlocks"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { datadogRum } from '@datadog/browser-rum';
import * as E from '@effect/data/Either';
import { constNull, pipe } from '@effect/data/Function';
import * as R from '@effect/data/ReadonlyRecord';
import * as S from '@effect/schema/Schema';
import { BlockDataProvider } from '@infl-ts/util-block-data-provider';
import { memoize } from '@infl-ts/util-function';
import { logError } from '@infl-ts/util-query-errors';
import * as Eq from 'fp-ts/Eq';
import * as Str from 'fp-ts/string';
import { memo } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { BlockConfig, ColumnBlockConfig, EntityBannerBlockConfig, MediaQueryBlockConfig, PortalBlockConfig, StickyBlockConfig } from './codecs';
import ColumnBlock from './layouts/column';
import EntityBannerBlock from './layouts/entity-banner';
import MediaQueryBlock from './layouts/media-query';
import PortalBlock from './layouts/portal';
import StickyBlock from './layouts/sticky';
import { LeafBlockConfigs } from './leafs/codecs';
import { ReportMissingBlock, resolveBlocksComponent } from './resolve-blocks';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var LayoutBlocks = {
  ColumnBlock: {
    "default": ColumnBlock,
    codec: ColumnBlockConfig
  },
  EntityBannerBlock: {
    "default": EntityBannerBlock,
    codec: EntityBannerBlockConfig
  },
  PortalBlock: {
    "default": PortalBlock,
    codec: PortalBlockConfig
  },
  StickyBlock: {
    "default": StickyBlock,
    codec: StickyBlockConfig
  },
  MediaQueryBlock: {
    "default": MediaQueryBlock,
    codec: MediaQueryBlockConfig
  }
};
var LayoutBlock = resolveBlocksComponent(LayoutBlocks, 'LayoutBlock');
var resolveLeafBlocks = memoize(function (leafBlocks) {
  return pipe(leafBlocks, R.map(function (block, key) {
    return {
      "default": block,
      schema: Object.keys(LeafBlockConfigs).includes("".concat(key, "Config")) ? LeafBlockConfigs["".concat(key, "Config")] : undefined
    };
  }), function (blocks) {
    return resolveBlocksComponent(blocks, 'LeafBlock');
  });
}, {
  primitive: true
});
var Block = /*#__PURE__*/memo(function (_ref) {
  var leafBlocks = _ref.leafBlocks,
      props = _objectWithoutProperties(_ref, _excluded);

  var LeafBlock = resolveLeafBlocks(leafBlocks);
  var Comp = Object.keys(LayoutBlocks).includes(props.block.typename) ? LayoutBlock : LeafBlock;
  return /*#__PURE__*/_jsx(Comp, _objectSpread(_objectSpread({}, props), {}, {
    leafBlocks: leafBlocks
  }));
}, function (prev, next) {
  return prev.block.hash === next.block.hash;
});
export var UnknownBlockList = function UnknownBlockList(_ref2) {
  var blocks = _ref2.blocks,
      href = _ref2.href,
      leafBlocks = _ref2.leafBlocks;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: blocks.map(function (block, i) {
      return pipe(block, S.validateEither(BlockConfig), E.match({
        onLeft: function onLeft(errors) {
          return /*#__PURE__*/_jsx(ReportMissingBlock, {
            errorType: "missing-matching-schema",
            data: block,
            parseError: errors
          }, i);
        },
        onRight: function onRight(block) {
          return /*#__PURE__*/_jsx(ErrorBoundary, {
            FallbackComponent: constNull,
            onError: function onError(err) {
              logError(err);
              datadogRum.addError(err);
            },
            children: /*#__PURE__*/_jsx(BlockDataProvider, {
              id: block.id,
              typename: block.typename,
              children: /*#__PURE__*/_jsx(Block, {
                block: block,
                href: href,
                leafBlocks: leafBlocks
              })
            })
          }, block.hash);
        }
      }));
    })
  });
};
export var MemoizedUnknownBlockList = /*#__PURE__*/memo(UnknownBlockList, Eq.struct({
  hash: Str.Eq
}).equals);